import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  Modal,
  Typography,
  useTheme,
} from "@mui/material";
import { memo, useEffect, useState } from "react";
import styled from "styled-components";

export interface CModalProps {
  title?: string;
  iconButton?: JSX.Element;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  iconSize?: "small" | "medium" | "large";
  onSave?: () => void;
  open?: boolean;
  children: JSX.Element;
  onClose?: () => void;
  loading?: boolean;
}

export const CModal = memo(
  ({
    title,
    iconButton,
    children,
    open,
    onClose,
    size,
    onSave,
    iconSize,
    loading,
  }: CModalProps) => {
    const [openState, setOpenState] = useState(false);
    const theme = useTheme();
    useEffect(() => {
      setOpenState(open ? open : false);
    }, [open]);

    const handleClose = () => {
      if (onClose) {
        onClose();
      }
      setOpenState(false);
    };

    return (
      <div>
        {iconButton && (
          <IconButton
            size={iconSize ? iconSize : "medium"}
            onClick={() => setOpenState(true)}
          >
            {iconButton}
          </IconButton>
        )}
        <Modal onClose={handleClose} open={openState}>
          <BoxStyle
            sx={{ maxWidth: theme.breakpoints.down(size ? size : "md") }}
          >
            <Grid container spacing={1} flexDirection="column">
              <Grid item>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    padding: "10px 25px 0px 25px",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="h6">{title}</Typography>
                  <IconButton onClick={(e) => handleClose()}>
                    <CloseIcon />
                  </IconButton>
                </Box>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item>
              <Box
                sx={{
                  width: "100%",
                  padding: "10px 25px",
                  maxHeight: "400px",
                  overflow: "hidden",
                  overflowY: "auto",
                }}
              >
                {children}
              </Box>
            </Grid>
            <Grid item>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "5px",
                  padding: "10px 25px",
                }}
              >
                <Button onClick={(e) => handleClose()}>Cancelar</Button>
                <Button onClick={(e) => onSave && onSave()} disabled={loading}>
                  {loading ? <CircularProgress size="22px" /> : "Salvar"}
                </Button>
              </Box>
            </Grid>
          </BoxStyle>
        </Modal>
      </div>
    );
  }
);

const BoxStyle = styled(Box)`
  position: absolute;
  top: 40%;
  left: 50%;
  /* padding: 10px 25px; */
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 800px;
  background-color: white;
  border-radius: 5px;
  box-shadow: 24;
`;
